import axios from 'axios'
import qs from 'qs'
// import { MessageBox, Message } from 'element-ui'
import {
	Message
} from 'element-ui'
import {
	getToken,
	setToken,
	removeToken
} from '@/utils/auth'
import store from '@/store'
// import { getToken } from '@/utils/auth'
import router from '../router'
axios.defaults.withCredentials = true //让ajax携带cookie
const service = axios.create({
	baseURL: process.env.VUE_APP_BASE_API, // api 的 base_url
	timeout: 300000, // 请求超时时间
	headers: {
		// 'X-Requested-With': 'XMLHttpRequest', // 就是这个自定义的请求头啊！！！，可以不需要的，注释了哈
		'Content-Type': 'multipart/form-data'
	}
})
// service.defaults.headers.get['content-type'] = 'application/json;charset=UTF-8'
// // // post请求头
// service.defaults.headers.post['content-type'] = 'application/x-www-form-urlencoded; charset=UTF-8'
// service.defaults.headers.post['content-type'] = 'Content-Type": "multipart/form-data'

// service.defaults.baseURL=  'http://122.51.183.123/v';
//export let weburl = "https://activitytest.gpp2019.com/v";
export let weburl = 'https://activity.gpp2019.com/v';
//export let weburl = 'http://10.237.234.18';
// export	let weburl = 'http://activitytest.gpp2019.com:8002/v';
//export	let weburl = 'http://10.237.234.78:80/';
service.interceptors.request.use(
	config => {
		let brand;
		if(JSON.parse(sessionStorage.getItem("userinfo")) && JSON.parse(sessionStorage.getItem("userinfo")).brand){
			brand = JSON.parse(sessionStorage.getItem("userinfo")).brand
		  }else{
			brand="gpp"
		  }
		if (process.env.NODE_ENV == 'development') {
			config.url = weburl + config.url
		}
		if (process.env.NODE_ENV == 'production') {
			config.url = weburl + config.url
		}
		// 判断是否存在token，如果存在的话，则每个http header都加上token
		if (getToken()) {
			config.headers.Authorization = 'Bearer ' + getToken()
		}
		console.log(config);
		// config.headers['content-type'] = 'application/json;charset=UTF-8'
		// config.data = qs.stringify(config.data)
		if (config.method === 'post') {
			let curPost = config.url.split('/')[config.url.split('/').length - 1]
      console.log(curPost)
			if (curPost === 'file' || curPost === 'importExcel') {
				console.log('文件上传..................................................')
				config.headers['content-type'] = 'multipart/form-data'
				return config // 这里对上传文件/图片的 api 不做传参序列化处理
			} else {
				// let data = config.data;
				// console.warn(data);
				// config.data = {
				// 	brand, //追加的参数
				// 	...data //拼接参数
				// }
				// console.log(config.data);
				config.headers['content-type'] = 'application/x-www-form-urlencoded; charset=UTF-8'
				// config.headers['content-type'] = 'application/json; charset=UTF-8';
				// config.headers['content-type'] = 'multipart/form-data';
				config.data = qs.stringify(config.data)
				return config
			}
		} else {
			// if (!config.params) {
      //   if(config.data){
      //     console.warn(JSON.parse(config.data))
      //   }
			// 	config.params = {
			// 		brand
			// 	}
			// } else {
			// 	!config.params.brand && typeof(config.params) === "object" &&  (config.params.brand = brand)
			// }
			config.headers['content-type'] = 'application/x-www-form-urlencoded; charset=UTF-8;application/json;charset=UTF-8'
			config.data = qs.stringify(config.data, {
				arrayFormat: 'repeat',
				allowDots: true
			})
		}
    console.log(config)
		return config
	},
	error => {
		console.log('qingqiu lanjie；', error)
		return Promise.reject(error)
	}
)
service.interceptors.response.use(
	response => {
		const res = response
		console.log('响应数据', res)
		if (res.status === 200) {
			if (res.data.code == '40001') {
				Message({
					message: res.data.message,
					type: 'error',
					duration: 3 * 1000
				})
			}
			if (res.data.code == '20001' || res.data.code == 70004) {
				Message({
					message: res.data.message,
					type: 'error',
					duration: 3 * 1000
				})
				store.dispatch('user/logout').then(res => {
					// if(res)
					// this.$router.replace('/login')
				})
			}
			return Promise.resolve(res)
		} else {
			return Promise.reject(res)
		}
	},
	error => {
		Message({
			message: error.message,
			type: 'error',
			duration: 5 * 1000
		})
	}
)

// // request interceptor
// service.interceptors.request.use(
//   config => {
//     console.log('config',config)
//     return config
//   },
//   error => {
//     return Promise.reject(error)
//   }

// )

// service.interceptors.response.use(
//   response => {
//     // const res = response.data
//     const res = response
//     console.log('res',res)

//     if (res.status === 200) {
//       return Promise.resolve(res)
//     } else {
//       return Promise.reject(res)
//     }

//     // // if the custom code is not 20000, it is judged as an error.
//     // if (res.code !== 20000) {
//     //   Message({
//     //     message: res.message || 'Error',
//     //     type: 'error',
//     //     duration: 5 * 1000
//     //   })

//     //   // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
//     //   if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
//     //     // to re-login
//     //     MessageBox.confirm('You have been logged out, you can cancel to stay on this page, or log in again', 'Confirm logout', {
//     //       confirmButtonText: 'Re-Login',
//     //       cancelButtonText: 'Cancel',
//     //       type: 'warning'
//     //     }).then(() => {
//     //       store.dispatch('user/resetToken').then(() => {
//     //         location.reload()
//     //       })
//     //     })
//     //   }
//     //   return Promise.reject(new Error(res.message || 'Error'))
//     // } else {
//     //   return res
//     // }
//   },
//   error => {
//     // console.log('err' + error) // for debug
//     // Message({
//     //   message: error.message,
//     //   type: 'error',
//     //   duration: 5 * 1000
//     // })
//     // return Promise.reject(error)

//     if (error.status) {
//       switch (error.status) {
//         case 400:
//           this.$message({
//             message: 'Bad Request 请求出现语法错误,一般是请求参数不对',
//             duration: 1000,
//             type: 'error'
//           })
//           break
//         case 401:
//           //  router.replace({
//           //      path: '/login',
//           //      query: { redirect: router.currentRoute.fullPath }
//           //  });
//           this.$message({
//             message: 'Unauthorized 访问被拒绝',
//             duration: 1000,
//             type: 'error'
//           })
//           break

//         case 403:
//           this.$message({
//             message: 'Forbidden 资源不可用',
//             duration: 1000,
//             type: 'error'
//           })
//           //  console.log('登录过期')

//           // 清除token
//           //  localStorage.removeItem('token');
//           //  store.commit('loginSuccess', null);
//           // 跳转登录页面，并将要浏览的页面fullPath传过去，登录成功后跳转需要访问的页面
//           //  setTimeout(() => {
//           //      router.replace({
//           //          path: '/login',
//           //          query: {
//           //              redirect: router.currentRoute.fullPath
//           //          }
//           //      });
//           //  }, 1000);
//           break
//         // 404请求不存在
//         case 404:
//           this.$message({
//             message: 'Not Found 无法找到指定位置的资源',
//             duration: 1500,
//             type: 'error'
//           })
//           break
//         case 500:
//           this.$message({
//             message: '服务器内部错误,请联系Java后台开发人员!!!',
//             duration: 1500,
//             type: 'error'
//           })
//           break
//         // 其他错误，直接抛出错误提示
//         default:
//           this.$message({
//             message: error.statusText,
//             duration: 1500
//           })
//           console.log(error.statusText)
//       }
//       return Promise.reject(error)
//     }
//   }
// )

export default service
